enum BillingMode {
	WithoutSuscriptionType = -1,
	PrepayWithoutPaymethodCurrently = 0,
	PrepayCreditCardAutomatic = 1,
	PrepayPaypalAutomatic = 2,
	PrepayCreditCardManual = 3,
	PrepayPaypalManual = 4,
	PayPerTransactionWithoutPaymethodCurrently = 5,
	PayPerTransactionCreditCard = 6,
	PayPerTransactionPaypal = 7,
	PrepayNewUserWithoutPaymethodCurrently = 8,
	PayPerTransactionNewUserWithoutPaymethodCurrently = 9,
	InvalidatedPaymethod = 10
}

export default BillingMode;
